export default {
  editLookup: '/admission-service/admission/lookup/editLookup',
  editDisableFlag: '/admission-service/admission/lookup/editDisableFlag',
  saveLookup: '/admission-service/admission/lookup/saveLookup',
  deleteLookupById: '/admission-service/admission/lookup/deleteLookupById',
  selectLookupByPage: '/admission-service/admission/lookup/selectLookupByPage',
  editLookupItem: '/admission-service/admission/lookup/editLookupItem',
  saveLookupItem: '/admission-service/admission/lookup/saveLookupItem',
  deleteLookupItemById: '/admission-service/admission/lookup/deleteLookupItemById',
  selectLookupItemByPage: '/admission-service/admission/lookup/selectLookupItemByPage',
  selectLookupItemByCode: '/admission-service/admission/lookup/selectLookupItemByCode',
  selectHealths: '/admission-service/admission/lookup/selectHealths'
}



// WEBPACK FOOTER //
// ./src/config/basedata/lookup/index.js